import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/services';
import { Router } from '@angular/router';
@Component({
    selector: 'app-report-dashboard',
    templateUrl: './report-dashboard.component.html',
    styleUrls: ['./report-dashboard.component.css'],
    standalone: false
})
export class ReportDashboardComponent {
   public powerBIDashBoardUrl: string;

  constructor(private authenticationService: AuthenticationService,
    public router: Router,) 
    {
    }

  public ngOnInit(): void {
    this.powerBIDashBoardUrl=this.authenticationService.getPowerBIUrl()
    window.open(this.powerBIDashBoardUrl, "_blank");
    setTimeout(() => {
      this.router.navigate(['/'])
    }, 100);
  }
}
